import React from "react";

const WindowsColor = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g clipPath="url(#windowcolora)">
            <path
                d="M34 7.827c-6.212 2.533-9.224 1.11-11.896-.665l-3.012 10.427c2.692 1.794 5.93 3.273 11.896.647l3.069-10.409H34Z"
                fill="#91C300"
            />
            <path
                d="M13.859 28.812C11.167 27.037 8.212 25.558 2 28.091l3.05-10.465c6.211-2.514 9.223-1.09 11.915.703l-3.106 10.483Z"
                fill="#00B4F1"
            />
            <path
                d="M17.473 16.443a10.258 10.258 0 0 0-5.835-2.09c-1.638-.018-3.596.444-6.062 1.443l3.05-10.428c6.23-2.533 9.223-1.11 11.915.684l-3.068 10.391Z"
                fill="#F8682C"
            />
            <path
                d="M18.565 19.346c2.71 1.775 5.703 3.198 11.915.665l-3.068 10.391c-6.212 2.533-9.205 1.11-11.897-.684l3.069-10.372h-.02Z"
                fill="#FFC300"
            />
        </g>
        <defs>
            <clipPath id="windowcolora">
                <path fill="#fff" transform="translate(2 4)" d="M0 0h32v27.733H0z" />
            </clipPath>
        </defs>
    </svg>
);

export default WindowsColor;
